import React from 'react';
import {HashLink as Link} from 'react-router-hash-link';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXTwitter,faYoutube,faGithub} from '@fortawesome/free-brands-svg-icons';
import {faEnvelope} from '@fortawesome/free-solid-svg-icons';
import logoFullLight from '../../assets/images/logo-full-light.png';
import locales from '../../locales/locales';
const Footer=({globalSettings})=>{
  return (
    <footer className='bg-gray-900 text-white py-12'>
      <div className='w-full px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
          <div>
            <Link to={`/${globalSettings.lang}/`} className='inline-block mb-4'>
              <img className='h-[32px]' src={logoFullLight}/>
            </Link>
            <p className='text-gray-400'>
              {locales.footerTagline[globalSettings.lang]}
            </p>
          </div>
          <div>
            <h4 className='text-lg font-semibold mb-4'>
              {locales.footerProduct[globalSettings.lang]}
            </h4>
            <ul className='space-y-2'>
              <li>
                <Link to={`/${globalSettings.lang}/#features`} className='text-gray-400 hover:text-white'>
                  {locales.footerFeatures[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/#how-it-works`} className='text-gray-400 hover:text-white'>
                  {locales.footerHowItWorks[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/#faq`} className='text-gray-400 hover:text-white'>
                  {locales.footerFAQ[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/pricing`} className='text-gray-400 hover:text-white'>
                  {locales.footerPricing[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/translator`} className='text-gray-400 hover:text-white'>
                  {locales.footerTranslator[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/contact`} className='text-gray-400 hover:text-white'>
                  {locales.footerFeedback[globalSettings.lang]}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className='text-lg font-semibold mb-4'>
              {locales.footerCompany[globalSettings.lang]}
            </h4>
            <ul className='space-y-2'>
              <li>
                <Link to={`/${globalSettings.lang}/about`} className='text-gray-400 hover:text-white'>
                  {locales.footerAbout[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/contact`} className='text-gray-400 hover:text-white'>
                  {locales.footerContact[globalSettings.lang]}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className='text-lg font-semibold mb-4'>
              {locales.footerLegal[globalSettings.lang]}
            </h4>
            <ul className='space-y-2'>
              <li>
                <Link to={`/${globalSettings.lang}/terms-of-service`} className='text-gray-400 hover:text-white'>
                  {locales.footerTermsOfService[globalSettings.lang]}
                </Link>
              </li>
              <li>
                <Link to={`/${globalSettings.lang}/privacy-policy`} className='text-gray-400 hover:text-white'>
                  {locales.footerPrivacyPolicy[globalSettings.lang]}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className='border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between'>
          <p className='text-gray-400'>
            {locales.footerCopyright[globalSettings.lang]}
          </p>
          <div className='flex space-x-4 mt-4 sm:mt-0'>
            {/*
            <a href='#' className='text-gray-400 hover:text-white' aria-label='X (Twitter)'>
              <span className='sr-only'>X (Twitter)</span>
              <FontAwesomeIcon icon={faXTwitter} className='h-6 w-6' />
            </a>
            */}
            <a href='https://www.youtube.com/@NekoTranslate' target='_blank' rel='noopener noreferrer' className='text-gray-400 hover:text-white' aria-label='YouTube'>
              <span className='sr-only'>YouTube</span>
              <FontAwesomeIcon icon={faYoutube} className='h-6 w-6' />
            </a>
            <a href='https://github.com/NekoTranslate' target='_blank' rel='noopener noreferrer' className='text-gray-400 hover:text-white' aria-label='GitHub'>
              <span className='sr-only'>GitHub</span>
              <FontAwesomeIcon icon={faGithub} className='h-6 w-6' />
            </a>
            <a href='mailto:contact@nekotranslate.ai' className='text-gray-400 hover:text-white' aria-label='Email'>
              <span className='sr-only'>Email</span>
              <FontAwesomeIcon icon={faEnvelope} className='h-6 w-6' />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;

